/* ============
 * AssetComponent
 * ============
 */

import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    assetComponents: [],
  },
  getters,
  mutations
};
